<template>
  <BaseTag v-bind="attrs"
           v-on="$listeners">
    <slot />
  </BaseTag>
</template>

<script>
  import BaseTag from '@base/base-tag'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TagLargePrimary',
    components: {
      BaseTag,
    },
    data: function () {
      return {
        attrs: {
          borderRadius: Layout.space.sm,
          cursor: {
            '': 'pointer',
            disabled: 'default',
          },
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.sm,
          fontWeight: FontStyle.weight.lg,
          padding: `${Layout.space.xs} ${Layout.space.sm}`,
        },
      };
    },
    created: function () {
      this.attrs = {
        ...this.attrs,
        backgroundColor: {
          '': this.color.dark6(),
          hover: this.color.select1(0.75),
          active: this.color.select1(),
          selected: this.color.select1(),
        },
        color: {
          '': this.color.dark3(),
          hover: this.color.light1(),
          active: this.color.light1(),
          selected: this.color.light1(),
        },
        ...this.$attrs,
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
